const isProduction = window._env_.REACT_APP_ENVIRONMENT === "production";
const baseImageUrl = isProduction
  ? "https://cdn.kthlaw.com/media/public/static/images"
  : "/static/images";

export const getImageUrl = (path) => `${baseImageUrl}/${path}`;
